@if (formLayout != null) {
    <div class="card-text PGForm">
        @if (!hideAdvanced && formLayout.hasAdvancedMode()) {
            <div class="text-end">
                <button class="btn btn-link" (click)="setAdvancedMode(!formLayout.advancedMode)">
                    <span>{{ (formLayout.advancedMode ? 'pg-form.advanced-mode-off' : 'pg-form.advanced-mode-on') | locTranslate }}</span>
                    <i class="fa-regular fa-fw {{ formLayout.advancedMode ? 'fa-eye-slash' : 'fa-eye' }}"></i>
                </button>
            </div>
        }
        <form #psForm="ngForm">
            @for (formGroup of formLayout.formGroups; track formGroup) {
                <div class="PGForm-Group" [appPgAnimations]="!formLayout.isGroupVisible(formGroup) ? 'ExitL' : 'EnterL'" pgAnimationsSkipFirst>
                    @if (formGroup.fields != null) {
                        @if (formGroup.title != null) {
                            <div class="row PGForm-Group-Head">
                                <div class="col-12">
                                    @if (formGroup.title != '') {
                                        <div class="PGForm-Group-Head-Title">
                                            <h4>{{formGroup.title | locTranslate}}</h4>
                                            @if (formGroup.collapsible) {
                                                <button class="btn btn-sm btn-secondary" (click)="formGroup.collapsed = !formGroup.collapsed">
                                                    <i class="fa-regular fa-{{formGroup.collapsed ? 'expand' : 'compress'}}"></i>
                                                </button>
                                            }
                                        </div>
                                    }
                                    <div class="border-top mt-2 mb-3"></div>
                                </div>
                            </div>
                        }
                        <div class="row PGForm-Group-Body" [appPgAnimations]="formGroup.collapsed ? 'ExitL' : 'EnterL'" pgAnimationsSkipFirst>
                            @if (formGroup.description != null) {
                                <div class="col col-12 mb-3" [innerHTML]="formGroup.description | locTranslate"></div>
                            }
                            @for (groupField of formGroup.fields; track groupField) {
                                @if (formLayout.getFieldByName(groupField.name); as fieldData) {
                                    <div class="col col-12 col-sm-{{formLayout.getFieldWidth(groupField)}}" [hidden]="formLayout.isFieldAlwaysHidden(groupField)" [appPgAnimations]="!formLayout.isFieldVisible(groupField) ? 'ExitL' : 'EnterL'" pgAnimationsSkipFirst>
                                        <div id="{{formId + '_' + fieldData.name}}"
                                            class="PGForm-Group-Element" [hidden]="groupField.display && groupField.display.invisible">
                                            <div class="PGForm-Group-Element-Inner {{getHighlightClass(groupField, formGroup)}}">
                                                <app-pg-form-field [disabled]="formDisabled" [languages]="languages" [forceLanguage]="forceLanguage" [currency]="currency" [name]="fieldData.name" [fieldData]="fieldData" [fieldList]="formLayout.fieldList" [display]="groupField.display" [constraintsValues]="constraintsValuesByField[fieldData.name]" [optionsFilter]="optionsFiltersByField[fieldData.name]" [(ngModel)]="fieldData.value" (ngModelChange)="onFieldValueChange(fieldData)" [groupId]="getGroupId()" [realmId]="getRealmId()" (setSlave)="onFieldSetSlave($event)"></app-pg-form-field>
                                                @if (getFieldIssue(fieldData.name); as issue) {
                                                    <div class="form-text text-danger">
                                                        <i class="fa-regular fa-circle-exclamation me-2"></i><ng-container *ngTemplateOutlet="fieldIssueTextTemplate; context: { issue: issue, locale: getIssueLocale(issue) }"></ng-container>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                        @if (formGroup.collapsed) {
                            <div class="row PGForm-Group-Collapsed">
                                <div class="col">...</div>
                            </div>
                        }
                    }
                </div>
            }
        </form>
        <ng-content></ng-content>
        @if (validationIssues != null) {
            <ul class="PGForm-Validation alert alert-warning" #validationElement>
                @for (issue of validationIssues; track issue) {
                    <li>
                        @if (issue.field != null) {
                            <a href="javascript:void(0)" (click)="scrollToField(issue.field, true)">{{issue.field.label | locTranslate}}@if (getIssueLocale(issue); as locale;) {
                                <span> ({{locale}})</span>
                            }</a>:
                        }
                        <ng-container *ngTemplateOutlet="fieldIssueTextTemplate; context: { issue: issue }"></ng-container>
                    </li>
                }
            </ul>
        }
    </div>
}
@if (hasSomeButton()) {
    <div class="card-buttons d-flex justify-content-between">
        <div>
            @if (extraActions != null) {
                @for (action of extraActions; track action) {
                    <button class="btn btn-{{action.color}} me-1" (click)="formExtraAction.emit(action.name)">
                        <i class="{{action.icon}}"></i><span [innerHTML]="action.label | locTranslate"></span>
                    </button>
                }
            }
        </div>
        <div>
            @if (hasCancel) {
                <button class="btn btn-secondary me-1" [disabled]="formDisabled" (click)="cancelForm()">
                    @if (cancelIcon != '') {
                        <i class="fa-regular {{cancelIcon != null ? cancelIcon : 'fa-times'}}"></i>
                        }<span [innerHTML]="cancelText == null ? ('pg-form.button-cancel' | locTranslate) : cancelText"></span>
                    </button>
                }
                @if (hasSubmit != false) {
                    <button class="btn btn-primary" [disabled]="formDisabled" (click)="submitForm()">
                        @if (submitIcon != '') {
                            <i class="fa-regular {{submitIcon != null ? submitIcon : 'fa-save'}}"></i>
                            }<span [innerHTML]="submitText == null ? ('pg-form.button-save' | locTranslate) : submitText"></span>
                        </button>
                    }
                </div>
            </div>
        }

        <ng-template #fieldIssueTextTemplate let-issue="issue" let-locale="locale">
            @if (issue.type == 'maxLength') {
                <span>{{ 'pg-form.issue-max-length' | locTranslate }}</span>
            }
            @if (issue.type == 'format') {
                <span>{{ 'pg-form.issue-format' | locTranslate }}</span>
            }
            @if (issue.type == 'required') {
                <span>
                    @if (issue.field == null || !issue.field.multi) {
                        {{ 'pg-form.issue-required' | locTranslate}}
                    }
                    @if (issue.field != null && issue.field.multi) {
                        {{ 'pg-form.issue-required-multi' | locTranslate}}
                    }
                    @if (locale) {
                        <span> ({{locale}})</span>
                    }
                </span>
            }
            @if (issue.type == 'min') {
                <span>{{ 'pg-form.issue-min' | locTranslate:'value':formatIssueValue(issue.value, issue.field) }}</span>
            }
            @if (issue.type == 'max') {
                <span>{{ 'pg-form.issue-max' | locTranslate:'value':formatIssueValue(issue.value, issue.field) }}</span>
            }
            @if (issue.type == 'constraints') {
                <span>
                    @for (constraint of issue.value; track constraint) {
                        <span locFormat="constraint" [formatValue]="constraint.operator" [formatParam]="formLayout.getFieldByName(constraint.field).label"></span>
                    }
                </span>
            }
            @if (issue.type == 'partial-language') {
                <span>{{ 'pg-form.issue-partial-language' | locTranslate }}</span>
            }
            @if (issue.custom != null) {
                <span>{{issue.custom}}</span>
            }
        </ng-template>